import React from 'react';

let uid = 0;

export const Diya = ({ size = 64, delay = 0, className = '' }) => {
  const id = React.useMemo(() => `diya-${++uid}`, []);
  return (
    <div
      className={`diwali-diya ${className}`}
      style={{ width: size, height: size, '--flicker-delay': `${delay}s` }}
      aria-hidden="true"
    >
      <div className="diwali-diya-halo" />
      <svg viewBox="0 0 100 100" width={size} height={size} className="diwali-diya-svg">
        <defs>
          <radialGradient id={`${id}-glow`} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FFF3B0" stopOpacity="0.95" />
            <stop offset="45%" stopColor="#FFB800" stopOpacity="0.45" />
            <stop offset="100%" stopColor="#FF8C00" stopOpacity="0" />
          </radialGradient>
          <linearGradient id={`${id}-flame`} x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#FF6A00" />
            <stop offset="45%" stopColor="#FFB300" />
            <stop offset="100%" stopColor="#FFF4C2" />
          </linearGradient>
          <linearGradient id={`${id}-bowl`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#B3121F" />
            <stop offset="55%" stopColor="#8E0B20" />
            <stop offset="100%" stopColor="#5C0A14" />
          </linearGradient>
          <linearGradient id={`${id}-rim`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#F5B700" />
            <stop offset="50%" stopColor="#FFE27A" />
            <stop offset="100%" stopColor="#D99A00" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="38" r="30" fill={`url(#${id}-glow)`} className="diwali-diya-glow" />
        <ellipse cx="50" cy="92" rx="30" ry="4" fill="#FFB800" opacity="0.25" className="diwali-diya-reflection" />
        <path d="M18 62 Q50 92 82 62 Q66 70 50 70 Q34 70 18 62 Z" fill={`url(#${id}-bowl)`} />
        <path d="M14 58 Q50 72 86 58 Q84 64 78 66 Q50 76 22 66 Q16 64 14 58 Z" fill={`url(#${id}-rim)`} />
        <ellipse cx="50" cy="59" rx="30" ry="6" fill="#3B0710" opacity="0.65" />
        <ellipse cx="50" cy="58" rx="20" ry="3.5" fill="#FFB300" opacity="0.55" />
        <rect x="48.5" y="48" width="3" height="10" rx="1.5" fill="#3B2A1A" />
        <g className="diwali-diya-flame">
          <path d="M50 14 C58 26, 62 34, 56 46 C54 50, 46 50, 44 46 C38 34, 42 26, 50 14 Z" fill={`url(#${id}-flame)`} />
          <path d="M50 26 C54 32, 55 38, 52 44 C51 46, 49 46, 48 44 C45 38, 46 32, 50 26 Z" fill="#FFF8DC" opacity="0.9" />
        </g>
        <g className="diwali-diya-sparks">
          <circle cx="42" cy="22" r="1" fill="#FFE27A" />
          <circle cx="60" cy="18" r="0.8" fill="#FFE27A" />
          <circle cx="55" cy="10" r="0.7" fill="#FFF" />
        </g>
      </svg>
    </div>
  );
};

export const CornerDiyas = () => (
  <div className="diwali-corner-diyas" data-testid="diwali-corner-diyas" aria-hidden="true">
    <Diya size={74} delay={0} className="diwali-diya-bl" />
    <Diya size={74} delay={0.7} className="diwali-diya-br" />
    <Diya size={54} delay={1.3} className="diwali-diya-tl" />
    <Diya size={54} delay={0.4} className="diwali-diya-tr" />
  </div>
);

export const DiyaRow = ({ count = 7, size = 42, className = '' }) => (
  <div className={`diwali-diya-row ${className}`} data-testid="diwali-diya-row" aria-hidden="true">
    <div className="diwali-garland" />
    <div className="diwali-diya-row-inner">
      {Array.from({ length: count }, (_, i) => (
        <Diya key={i} size={size} delay={i * 0.35} className={i % 2 ? 'diwali-diya-row-hide-sm' : ''} />
      ))}
    </div>
    <div className="diwali-garland" />
  </div>
);
